export default {
  title: 'Contact et synchronisation',
  labels: {
    occ_phone_number: "Numéro du centre d'appels",
    company_phone_number: 'Numéro de téléphone du restaurant',
    has_google_business_sync: 'Synchroniser avec Google Business',
    has_foodamigos_sync: 'Synchroniser avec les services Fooodamigos',
  },
  placeholders: {
    occ_phone_number: 'Sélectionner un numéro dans la liste',
  },
};
